// Split notes are independent notes, so each gets its own stem direction.
// Keep the legacy shared setting for unsplit notes/chords.
export function givenNoteStemUp(note, index, clef = "treble") {
  if (!note.split) return note.stemUp;
  const override = note.stemUps?.[index];
  if (typeof override === "boolean") return override;
  const pitch = String(note.pitches?.[index] || "").match(/^([A-Ga-g])[^\d-]*(-?\d+)$/);
  if (!pitch) return true;
  const position = Number(pitch[2]) * 7 + "CDEFGAB".indexOf(pitch[1].toUpperCase());
  const middle = { treble: 34, bass: 22, alto: 28, tenor: 26 }[clef] ?? 34;
  return position < middle;
}
